import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import AccountChatPageUI from './AccountChatPageUI.js'

class AccountChatPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      latestMessage: null,
      searchFilter: '',
      accountList: null,
      userList: null,
      checked: false
    }
  }

  render() {
    return (
      <AccountChatPageUI
        context={this.props.context}
        account={this.state.account}
        filteredList={this.state.filteredList}
        userList={this.state.userList}
        errorList={this.state.errorList}
        onRefreshClick={this.onRefreshClick}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        //
        checked={this.state.checked}
        onShowUnread={this.onShowUnread}
      />
    )
  }

  onShowUnread = () => {
    let context = this.props.context
    let newChecked = !this.state.checked
    this.setState({
      checked: newChecked
    })
    this.getChatsA(context)
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccount(context)
    this.getChatsA(context)
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.accountId === prevProps.match.params.accountId)
      return
    window.location.reload()
  }

  getAccount(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Account(this.props.match.params.accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  getChatsA(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/chatMessages/statuses/recent/unread/draft`,
      cacheKey: CacheKeys.Chats(),
      callback: this.getChatsACallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getChatsACallback = (response) => {
    let accountList = response.accountMessageList.map((account) => {
      return {
        accountId: account.accountId, accountName: account.accountName,
        latestMessage: account.latestMessage, noOfUnreadMessages: account.noOfUnreadMessages,
        latestDraftMessage: account.latestDraftMessage
      }
    })

    let unreadList = accountList.filter(account => account.noOfUnreadMessages > 0)

    let account = response.accountMessageList.filter(acc => acc.accountId === this.props.match.params.accountId)[0]
    let userList = account.userMessageList.map((user) => {
      return {
        accountId: account.accountId, accountName: account.accountName,
        userId: user.userId, userName: user.addressableName === null ? user.phoneNumber : user.addressableName,
        latestMessage: user.latestMessage, noOfUnreadMessages: user.noOfUnreadMessages,
        latestDraftMessage: user.latestDraftMessage
      }
    })

    let filtersStr = sessionStorage.getItem(CacheKeys.AccountUsersFilter(this.props.match.params.accountId, this.props.match.params.userId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(this.state.checked ? unreadList : accountList, userList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.accountList, this.state.userList, searchFilter)
  }

  applyFilters(accountList, userList, searchFilter, errorList) {
    let filteredList = accountList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(acc =>
        acc.accountName.toLocaleLowerCase().includes(searchFilter) ||
        (acc.userName && acc.userName.toLocaleLowerCase().includes(searchFilter))
      )
    }

    this.setState({
      accountList: accountList,
      userList: userList,
      filteredList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.AccountUsersFilter(this.props.match.params.accountId, this.props.match.params.userId), JSON.stringify(filters))
  }

  // onDeleteClick = (event) => {
  //     if (this.state.deleteSubmitted)
  //         return

  //     let rowId = event.target.getAttribute('data-row-id')
  //     this.setState({
  //         deleteSubmitted: true,
  //         deleteErrorList: [],
  //         selectedRowId: rowId
  //     })

  //     RestApiUtils.delete(this.props.context,
  //         `/api/su/messageLists/${rowId}`,
  //         this.onDeleteClickCallback, {}
  //     )
  // }

  // onDeleteClickCallback = (response) => {
  //     let errorList = []
  //     if (response.errorList.length) {
  //         response.errorList.forEach(error => {
  //             errorList.push(error.message)
  //         })
  //     }

  //     this.setState({
  //         deleteSuccessMsg: response.success,
  //         deleteErrorList: errorList,
  //         deleteSubmitted: false,
  //     })

  //     if (errorList.length === 0) {
  //         setTimeout(() => {
  //             this.setState({ deleteSuccessMsg: null, deleteErrorList: [] })
  //             this.onRefreshClick('noBusy')
  //         }, 2000)
  //     }
  // }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Chats())

    this.setState({
      errorList: null,
      userList: null,
      latestMessage: null,
    }, () => {
      this.getChatsA(context)
    })
  }
}

export default withRouter(AccountChatPageSF)
